import {Form, Input, Radio, Space, Button, message, Spin, Card, Typography, Row, Col} from "antd";
import React, {useEffect, useState}  from "react";
import {useNavigate, useParams } from "react-router-dom";
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import {CloseOutlined, SaveOutlined, LockOutlined, UserOutlined, KeyOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";

const { Title, Text } = Typography;

export const Axios = axios.create({
    baseURL: process.env.REACT_APP_APPI_ADDRESS
});

const FormChangeUsserPassword = ({}) => {

    const headers = {
        'accept': '*/*',
        'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
        'Content-Type': 'application/json',
      };

    const { t, i18n } = useTranslation();

    const [messageApi, contextHolder] = message.useMessage();

    const [spinning, setSpinning] = useState(false);

    const spinTitle = t('global.processing_data');

    let infor_user = (sessionStorage.getItem('user_mod'))? JSON.parse(sessionStorage.getItem('user_mod')):null;

    const navigate = useNavigate();

    const { id } = useParams();

    const [form] = Form.useForm();

    useEffect(() => {
        // Resetea los campos del formulario al montarse el componente
        form.resetFields();

        if(id !== infor_user.idusuario)
               navigate('/usuarios');
        
    }, []);


    const cancelar = (values) => {
        navigate('/usuarios');
    };

    const onFinish = (values) => {
        setSpinning(true);
        Axios.post("mts/changePasswordUsser",
            {
              "idusuario": id,
              "contrasenna": values.contrasenna,
            },
            {
                headers: headers
              }
          ).then(response => {
             setSpinning(false);
             if(response.data.success){
                messageApi.open({
                    type: 'success',
                    content: t('info.success'),
                    duration: 0,
                });

                setTimeout(messageApi.destroy, 2500);
                navigate('/usuarios');
            }else{
                messageApi.open({
                    type: 'error',
                    cocontent: t('info.error'),
                    duration: 0,
                });

                setTimeout(messageApi.destroy, 2500);
            }
        })
        .catch(error => {
            setSpinning(false);
            messageApi.open({
                type: 'error',
                cocontent: t('info.error'),
                duration: 0,
            });
            setTimeout(messageApi.destroy, 2500);
        });
      };


      const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
      };

    return (
        <div style={{
            minHeight: "100vh",
            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
            padding: "24px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }}>
            <Spin spinning={spinning} tip={spinTitle} size={"large"}>
                <Card
                    style={{
                        width: "100%",
                        maxWidth: "500px",
                        borderRadius: "16px",
                        boxShadow: "0 8px 32px rgba(37, 50, 137, 0.15)",
                        border: "none",
                        background: "white"
                    }}
                >
                    {/* Header del formulario */}
                    <div style={{
                        background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                        borderRadius: '12px',
                        padding: '24px',
                        marginBottom: '32px',
                        color: 'white',
                        textAlign: 'center'
                    }}>
                        <KeyOutlined style={{ fontSize: '32px', marginBottom: '12px' }} />
                        <Title level={2} style={{ color: 'white', margin: 0 }}>
                            {t('usser.change_password')}
                        </Title>
                        <Text style={{ color: 'rgba(255,255,255,0.8)', fontSize: '14px' }}>
                            {infor_user ? `Cambiar contraseña para: ${infor_user.correo}` : 'Establecer nueva contraseña'}
                        </Text>
                    </div>
                    {contextHolder}
                    <Form
                        form={form}
                        autoComplete="off"
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        layout="vertical"
                        name="form_change_password"
                        initialValues={{
                            activo: 1,
                        }}
                        style={{ padding: '0 24px 24px 24px' }}
                    >


                        <div style={{
                            background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                            borderRadius: '12px',
                            padding: '24px',
                            marginBottom: '24px',
                            border: '1px solid #e0e6ff'
                        }}>
                            <Form.Item
                                name="contrasenna"
                                label={<span style={{ color: '#253289', fontWeight: '500' }}>{t('usser.password')}</span>}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Por favor debe escribir la contraseña!',
                                    },
                                    {min: 8, message: 'Debe introducir al menos 8 caracteres'}
                                ]}
                                hasFeedback
                            >
                                <Input.Password
                                    prefix={<LockOutlined style={{ color: '#253289' }} />}
                                    placeholder="Mínimo 8 caracteres"
                                    size="large"
                                    style={{ borderRadius: '8px' }}
                                />
                            </Form.Item>

                            <Form.Item
                                name="confirm"
                                label={<span style={{ color: '#253289', fontWeight: '500' }}>{t('usser.confirm_password')}</span>}
                                dependencies={['contrasenna']}
                                hasFeedback
                                rules={[
                                    {
                                        required: true,
                                        message: 'Por favor confirma la contraseña!',
                                    },
                                    ({getFieldValue}) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('contrasenna') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error('Las contraseñas no coinciden!'));
                                        },
                                    }),
                                ]}
                            >
                                <Input.Password
                                    prefix={<LockOutlined style={{ color: '#253289' }} />}
                                    placeholder="Confirme la contraseña"
                                    size="large"
                                    style={{ borderRadius: '8px' }}
                                />
                            </Form.Item>
                        </div>

                        <div style={{
                            background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                            borderRadius: '12px',
                            padding: '24px',
                            textAlign: 'center',
                            border: '1px solid #e0e6ff'
                        }}>
                            <Space size="large">
                                <Button
                                    icon={<CloseOutlined />}
                                    danger
                                    onClick={cancelar}
                                    size="large"
                                    style={{
                                        borderRadius: '8px',
                                        minWidth: '120px',
                                        height: '44px',
                                        fontWeight: '500'
                                    }}
                                >
                                    {t('global.cancel')}
                                </Button>
                                <Button
                                    icon={<SaveOutlined />}
                                    type="primary"
                                    htmlType="submit"
                                    size="large"
                                    style={{
                                        background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                                        borderColor: '#253289',
                                        borderRadius: '8px',
                                        minWidth: '120px',
                                        height: '44px',
                                        fontWeight: '500',
                                        boxShadow: '0 4px 12px rgba(37, 50, 137, 0.3)'
                                    }}
                                >
                                    {t('global.save')}
                                </Button>
                            </Space>
                        </div>

                    </Form>
                </Card>
            </Spin>
        </div>

    );
};

export default FormChangeUsserPassword;